import cloneDeep from 'lodash/cloneDeep'
import baseDefaults from '../Base/Base.defaults'

export default {
  ...cloneDeep(baseDefaults),
  color: 'var(--color-primary)',
  badgeText: 'FACT',
  bodyText: 'Creating urgency on a sales page can increase your conversion rate by as much as 332%.'
}
